import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {EMAIL_SPAM_CHECK_QUERY_KEY} from "../queryKeys";
import {ReachEmailSpamCheckResult} from "./types";

type Variables = {mailboxId: string};

const getEmailSpamCheck = async (variables: Variables): Promise<ReachEmailSpamCheckResult> => {
  const response = await axiosReachInstance.get<ReachEmailSpamCheckResult, AxiosResponse<ReachEmailSpamCheckResult>>(
    `/templates/spam-check/${variables.mailboxId}`
  );
  return response.data;
};

export const useGetEmailSpamCheck = (
  variables: Variables,
  options?: BaseQueryOptions<ReachEmailSpamCheckResult, Variables>
): BaseUseQueryResult<ReachEmailSpamCheckResult> =>
  useBaseQuery<ReachEmailSpamCheckResult, Variables>(
    [EMAIL_SPAM_CHECK_QUERY_KEY, variables.mailboxId],
    getEmailSpamCheck,
    variables,
    options
  );
